// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"305":"46669e701ecc18fe","1921":"27d19d9114268ede"}[chunkId] + ".js";
};